export const NAVIGATION = {
  ACCOUNT_SIGN_IN: '/accounts/sign-in',
  ACCOUNT_SIGN_OUT: '/accounts/sign-out',
  SCHEDULE: '/schedule',
  TIMESHEETS: '/timesheets',
  TEAM: '/team',
  SETTINGS: '/settings',
  GENERAL_SETTINGS: '/settings/location/basic_info',
  WEB_TIME_CLOCK: '/web_timeclock',
  EMPLOYEES: '/employees',
};
